import React, { useEffect, useState } from 'react';
import { SearchBox } from '../components/micro/SearchBox/SearchBox';
import { Card } from '../components/micro/Card/Card';
import { ReportList } from '../components/micro/ReportList/ReportList';
import './ReportHistory.scss';

import { usePortContext } from '../service/MessageChannelContext';
import { useNavigate } from 'react-router-dom';
import xIcon from '../images/x-icon.png';
import moment from 'moment';

const content = {
  deleteAll: {
    en: 'Delete All',
    id: 'Hapus Semua',
  },
};

const ReportSkinHistory = () => {
  const {
    historyData,
    events: { emitDeleteAnalysisEvent, emitDeleteAllEvent },
    lang,
  } = usePortContext();
  const navigate = useNavigate();

  const [reportHistory, setReportHistory] = useState([]);

  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    if (historyData) {
      setReportHistory(historyData?.analyses);
    }
  }, [historyData]);

  const filteredReports = reportHistory.filter((report) =>
    moment(report.createdAt).format('D MMM YYYY h:mm A').toLowerCase().includes(searchValue.toLowerCase()),
  );

  return (
    <div className="report-history">
      <Card title="Skin Report History">
        <img src={xIcon} alt="XIcon" className="x-icon" onClick={() => navigate('/mySkinDiary')} />
        <SearchBox placeholder={'Search by date'} value={searchValue} onChange={(e) => setSearchValue(e.target.value)} />
        <ReportList
          reports={filteredReports}
          showDelete
          onDelete={emitDeleteAnalysisEvent}
          onClick={(analysisId) => {
            navigate(`/skinReport`, { state: reportHistory.find((report) => report.analysisId === analysisId) });
          }}
        />
        <div className="footer">
          <div className="total-count">{`Total ${filteredReports.length} items`}</div>
          <div className="delete-all" onClick={emitDeleteAllEvent}>
            {content.deleteAll[lang]}
          </div>
        </div>
      </Card>
    </div>
  );
};

export default ReportSkinHistory;
